import { useCallback, useLayoutEffect, useRef } from 'react'
import type { RefObject } from 'react'

/** A ref that always holds the value of the last render, for callbacks that must not change identity. */
export const useLatest = <T>(value: T): RefObject<T> => {
  const ref = useRef(value)
  useLayoutEffect(() => {
    ref.current = value
  })
  return ref
}

/** A function of stable identity that calls the latest `fn`: an event handler a memoised child can take. */
export const useStableCallback = <A extends unknown[], R>(fn: (...args: A) => R): ((...args: A) => R) => {
  const latest = useLatest(fn)
  return useCallback((...args: A) => latest.current(...args), [latest])
}
